export { default } from './ReactTableComponent';
